import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
        <div class="header">
            <div class="row2">
                <div class="col00 small">
                    <div class="heading01 type01">
                        <h1>
                            <img
                                ng-if="vm.$rootScope.surveyGroup.logoFileName"
                                ng-src="{{ vm.CompanyService.getLogoImage(
                                    vm.$rootScope.surveyGroup.logoFileName,
                                    vm.$rootScope.surveyGroup.companyId,
                                    'smallHeaderLogo'
                                ) }}"
                                height="40"
                            />
                        </h1>
                        <p class="center">
                            <span ng-if="vm.isReportView">{{ vm.MomentService.formatTimeStamp(vm.$rootScope.surveyGroup.deadline) }}</span>
                            <strong>{{ vm.surveyGroupI18n.name }}</strong>
                        </p>
                        <div class="quizdata" ng-if="!vm.isFinishedView">
                            <select class="form-control"
                                    ng-model="vm.language"
                                    ng-change="vm.changeLanguage()"
                                    ng-if="vm.$rootScope.surveyGroup"
                                    ng-options="language.toLowerCase() as vm.COMPANY_LANGUAGE_ENUM.DROPDOWN_LABELS_IN_NATIVE[language]
                                                for language in vm.$rootScope.surveyGroup.companyLanguages
                                                track by language.toLowerCase()">
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `
})
export default class {
    constructor ($translate, $rootScope, $state, lodash,
                 UserResource, TranslationService, MomentService, CompanyService,
                 COMPANY_LANGUAGE_ENUM, USER_SWITCH_LANGUAGE_SOURCE_ENUM) {
        this.$translate = $translate;
        // todo: fix using $rootScope for variables
        this.$rootScope = $rootScope;
        this.lodash = lodash;
        this.TranslationService = TranslationService;
        this.UserResource = UserResource;
        this.MomentService = MomentService;
        this.CompanyService = CompanyService;
        this.COMPANY_LANGUAGE_ENUM = COMPANY_LANGUAGE_ENUM;
        this.USER_SWITCH_LANGUAGE_SOURCE_ENUM = USER_SWITCH_LANGUAGE_SOURCE_ENUM;
        this.language = $translate.proposedLanguage() ? $translate.proposedLanguage() : $translate.use();
        this.isFinishedView = $state.includes('survey.survey.finished');
        this.isReportView = $state.includes('survey.report');
        this.$rootScope.$on('survey.loaded', () => {
            if (this.$rootScope.formSubmission && this.$rootScope.formSubmission.user) {
                this.language = this.$rootScope.formSubmission.user.coursyLanguage.toLowerCase();
            }
            this.surveyGroupI18n = this.getSurveyGroupI18n();
        });
    }

    getSurveyGroupI18n () {
        let surveyGroupI18n = this.lodash.find(this.$rootScope.surveyGroup.surveyGroupI18ns, (i18n) => {
            return this.language.toUpperCase() === i18n.language;
        });

        if (!surveyGroupI18n) {
            surveyGroupI18n = this.lodash.find(this.$rootScope.surveyGroup.surveyGroupI18ns, (i18n) => {
                return this.$rootScope.surveyGroup.companyLanguage === i18n.language;
            });
        }

        return surveyGroupI18n;
    }

    changeLanguage () {
        this.TranslationService.changeLanguage(this.language).then((data) => {
            if (this.$rootScope.formSubmission) {
                this.UserResource
                    .switchCoursyLocale({
                        coursyLanguage: this.language.toUpperCase(),
                        switchSourceType: this.USER_SWITCH_LANGUAGE_SOURCE_ENUM.KEYS.SURVEY,
                        switchSourceGuid: this.$rootScope.formSubmission.guid
                    })
                    .$promise
                    .then(() => {
                        this.surveyGroupI18n = this.getSurveyGroupI18n();
                        this.$rootScope.$emit('survey:language', data);
                    });
            }
            else {
                this.surveyGroupI18n = this.getSurveyGroupI18n();
                this.$rootScope.$emit('survey:language', data);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/header/survey/index.js